import React from "react";
import mosque from "../../assets/img/jama-masjid.jpg";

const AddMosque = () => {
  return (
    <>
      <div className="addMosqueSec p-30">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8">
              <div className="mosqueTitle">
                <h2> MOSQUE DETAILS OF INDIA</h2>
              </div>
              <div className="addMosqueForm">
                <form className="form row">
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label>Name of Mosque</label>
                      <input
                        type="text"
                        placeholder="Masjid"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Enter City</label>
                      <input
                        type="text"
                        placeholder="city"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>State</label>
                      <input
                        type="text"
                        placeholder="State"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Langitude</label>
                      <input
                        type="text"
                        placeholder="Masjid"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Name of Imam Sahab</label>
                      <input
                        type="text"
                        placeholder="Imam Name"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Name of Mutwalli</label>
                      <input
                        type="text"
                        placeholder="Masjid"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Student Name (20+ Age)</label>
                      <input
                        type="text"
                        placeholder="Student Name"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label>Name of Village</label>
                      <input
                        type="text"
                        placeholder="village"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>District</label>
                      <input
                        type="text"
                        placeholder="example..."
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Latitude</label>
                      <input
                        type="text"
                        placeholder="latitude"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>RTO Code</label>
                      <input
                        type="number"
                        placeholder="RTO CODE"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Imam Mobile Number</label>
                      <input
                        type="number"
                        placeholder="Imam mobile Number"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Mutwalli Mobile Number</label>
                      <input
                        type="number"
                        placeholder="Mutwalli mobile number"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>Student Mobile Number</label>
                      <input
                        type="number"
                        placeholder="Student mobile number"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <button className="btn bgBlue text-white">
                        Add Mosque
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="mosqueBuilding">
                <img src={mosque} alt="mosque" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="searchCode bgGray">
                <div className="mosqueTitle">
                  <h2>NAMAZ TIME TABLE</h2>
                </div>
                <form className="form">
                  <div className="form-group">
                    <label>Search By Code</label>
                    <input
                      type="text"
                      placeholder="Type code here"
                      className="form-control"
                    />
                  </div>
                </form>
                <div className="nameTimeTable">
                  <ul>
                    <li>
                      <span>Fajr</span>
                      <strong>05:00 AM</strong>
                    </li>
                    <li>
                      <span>Johar</span>
                      <strong>01:00 PM</strong>
                    </li>
                    <li>
                      <span>Asar</span>
                      <strong>04:00 PM</strong>
                    </li>
                    <li>
                      <span>Magrib</span>
                      <strong>05:30 PM</strong>
                    </li>
                    <li>
                      <span>Isha</span>
                      <strong>07:00 PM</strong>
                    </li>
                    <li>
                      <span>JUMMA</span>
                      <strong>01:00 PM</strong>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="addMosqueForm"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMosque;
